import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  DialogActions,
  FormControl,
  DialogContent,
  DialogTitle,
  CircularProgress,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  Radio,
  FormHelperText,
} from "@material-ui/core";
import { useStyles } from "../style";
import {
  commonValidationInput,
  adminModeValidationInput,
  orgModeValidationInput,
} from "./validation";
import withMiddleware from "../../../../middleware";
import CustomAutoComplete from "../../../../components/auto-complete";
import useForm from "../../../../hooks/useForm";
import { GroupSelection } from "../../../../components/group-select";
import { getGroupsList } from "../../../../components/group-select/handler";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  role: "user",
  groupIds: undefined,
  userToInviteId: undefined,
  payment_responsibility: "org_pays",
};

function SendInvite(props) {
  const {
    openSendInvite,
    closeHandler,
    addHandler,
    currentUser,
    loader,
    isAdminMode,
    isGroupMode,
  } = props;
  const memberRoleHelperText = "Standard access to their own account.";
  const [roleHelperText, setRoleHelperText] = useState(memberRoleHelperText);
  const classes = useStyles();
  const { values, errors, handleChange, handleFormSubmit, setValues } = useForm(
    initialValues,
    isAdminMode
      ? adminModeValidationInput
      : isGroupMode
        ? commonValidationInput
        : orgModeValidationInput,
    handleSendInvite,
  );
  const [groups, setGroups] = useState([]);

  function handleSendInvite(values) {
    // Map UI-only payment_responsibility to backend orgPays boolean
    const {
      payment_responsibility = "org_pays",
      ...rest
    } = values;
    const orgPays = payment_responsibility === "org_pays";

    // Only send fields the backend schema accepts
    addHandler({
      ...rest,
      orgPays,
    });
  }

  function handleClose() {
    // Reset form when dialog is closed so fields and summary strip are in sync
    setValues(initialValues);
    setRoleHelperText(memberRoleHelperText);
    closeHandler(false);
  }

  console.log(errors, ":errors");

  return (
    <div className={classes.root}>
      {loader && (
        <Grid
          container
          className={classes.loader}
          justify="center"
          alignItems="center"
          alignContent="center"
        >
          <CircularProgress />
        </Grid>
      )}
      <Dialog
        open={openSendInvite}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
        classes={classes.dialog}
      >
        <DialogTitle id="form-dialog-title" className={classes.dialogHeader}>
          {isAdminMode
            ? "Invite user to any organization"
            : "Invite user to your organization"}
        </DialogTitle>
        {/* Quick summary strip at top */}
        <div
          style={{
            backgroundColor: "#F5F5F5",
            padding: "8px 24px",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <FormHelperText
            component="p"
            style={{
              margin: 0,
            }}
          >
            Inviting{" "}
            <span style={{ fontWeight: 600 }}>
              {values?.firstName || values?.lastName
                ? `${values.firstName || ""} ${values.lastName || ""}`.trim()
                : "a new user"}
            </span>{" "}
            as{" "}
            <span style={{ fontWeight: 600 }}>
              {values?.role === "org"
                ? "organization admin"
                : values?.role === "group"
                  ? "group admin"
                  : "member"}
            </span>{" "}
            — payer:{" "}
            <span style={{ fontWeight: 600 }}>
              {values?.role === "user"
                ? values?.payment_responsibility === "user_pays"
                  ? "user"
                  : "organization"
                : "organization"}
            </span>
            .
          </FormHelperText>
        </div>
        <DialogContent className={classes.paddingSpacer}>
          <FormControl fullWidth>
            <Grid container spacing={2}>
              {/* Invite details */}
              <Grid item xs={6}>
                <TextField
                  label="First name*"
                  variant="outlined"
                  type="text"
                  size="small"
                  inputProps={{
                    maxLength: "50",
                  }}
                  fullWidth
                  error={errors["firstName"]}
                  helperText={errors["firstName"]}
                  onChange={(e) => handleChange("firstName", e.target.value)}
                  value={values?.firstName || ""}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Last name*"
                  variant="outlined"
                  type="text"
                  size="small"
                  inputProps={{
                    maxLength: "50",
                  }}
                  fullWidth
                  error={errors["lastName"]}
                  helperText={errors["lastName"]}
                  onChange={(e) => handleChange("lastName", e.target.value)}
                  value={values?.lastName || ""}
                />
              </Grid>
              {isAdminMode ? (
                <Grid item xs={6}>
                  <CustomAutoComplete
                    service={props?.service}
                    url="/org/search_orgs"
                    mapper={(row) => ({ label: row?.name, value: row?.id })}
                    onChange={(option) => {
                      handleChange("orgId", option?.value || "");
                      // TODO: DO this logic which should reset the group list based on the org_id...
                      // TODO: Pass the clear all prop to the group select
                      // handleChange("groupId", undefined);
                      if (option?.value) {
                        // setGroups([]);
                        // TODO: pass the group id to the group selection component.
                        // getGroupsList(props.service, option?.value).then(setGroups);
                      } else {
                        // setGroups([]);
                      }
                    }}
                    inputLabel="Organization*"
                    inputPlaceholder="Search by name or domain name"
                    error={errors["orgId"]}
                    helperText={errors["orgId"]}
                  />
                </Grid>
              ) : null}
              {!isGroupMode ? (
                <Grid item xs={6}>
                  <GroupSelection
                    multiple={false}
                    label="Group*"
                    name="groupId"
                    org_id={values?.orgId}
                    service={props?.service}
                    error={errors?.groupId}
                    handleChange={(name, value) =>
                      handleChange(name, Number(value))
                    }
                  />
                </Grid>
              ) : null}
              {/* We don't want this now as we should be able to invite anyone */}
              {/* {isAdminMode ? (
                <Grid item xs={6}>
                  <CustomAutoComplete
                    service={props?.service}
                    url="/org/invitation/users"
                    mapper={(row) => ({ label: `${row?.first_name} ${row?.last_name} - ${row?.email}`, ...row })}
                    onChange={(option) => {
                      handleChange("email", option?.email || "");
                      handleChange("firstName", option?.first_name || "");
                      handleChange("lastName", option?.last_name || "");
                      handleChange("userToInviteId", option?.user_id);
                      autoValidateV2(user);
                    }}
                    inputLabel="User*"
                    inputPlaceholder="Search by email or name"
                  />
                </Grid>
              ) : null} */}
              <Grid item xs={6}>
                <TextField
                  label="Email*"
                  variant="outlined"
                  // className={classes.miniFieldBottom}
                  type="text"
                  size="small"
                  inputProps={{
                    maxLength: "50",
                  }}
                  fullWidth
                  error={errors["email"]}
                  helperText={errors["email"]}
                  onChange={(e) => handleChange("email", e.target.value)}
                  value={values?.email}
                />
              </Grid>
              {/* {isAdminMode ? null : (
                <Grid item xs={12}>
                  <FormControlLabel
                    labelPlacement="end"
                    label={<Typography variant="body2">I'm sure an OptimalHRV account exists against this email</Typography>}
                    control={<Checkbox size="small" value="checked" color="primary" className={classes.checkbox} />}
                    onChange={(e) => handleChange("sure", e.target.checked)}
                  />
                </Grid>
              )} */}
              {/* Access level (role) */}
              <Grid item xs={12}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Access level</FormLabel>
                  <RadioGroup
                    row
                    aria-label="role"
                    name="role"
                    defaultValue="user"
                    value={values?.role}
                    onChange={(e) => {
                      const newRole = e.target.value;
                      handleChange("role", newRole);
                      if (newRole === "org") {
                        setRoleHelperText(
                          "Full access to all groups, users, and organization settings.",
                        );
                      }
                      if (newRole === "group") {
                        setRoleHelperText(
                          "Manage users and data within the selected group(s) only.",
                        );
                      }
                      if (newRole === "user") {
                        setRoleHelperText(memberRoleHelperText);
                      }
                    }}
                  >
                    {isGroupMode ? null : (
                      <FormControlLabel
                        value="org"
                        control={<Radio />}
                        label="Organization admin"
                      />
                    )}
                    <FormControlLabel
                      value="group"
                      control={<Radio />}
                      label="Group admin"
                    />
                    <FormControlLabel
                      value="user"
                      control={<Radio />}
                      label="Member (user)"
                    />
                  </RadioGroup>
                  <FormHelperText
                    style={{
                      fontStyle: "italic",
                    }}
                  >
                    {roleHelperText}
                  </FormHelperText>
                </FormControl>
              </Grid>
              {/* Subscription payment */}
              {values?.role === "user" && (
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      Subscription payment
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-label="payment-responsibility"
                      name="payment_responsibility"
                      value={values?.payment_responsibility}
                      onChange={(e) =>
                        handleChange("payment_responsibility", e.target.value)
                      }
                    >
                      <FormControlLabel
                        value="org_pays"
                        control={<Radio />}
                        label="Organization pays"
                      />
                      <FormControlLabel
                        value="user_pays"
                        control={<Radio />}
                        label="User pays"
                      />
                    </RadioGroup>
                    <FormHelperText
                      style={{
                        fontStyle: "italic",
                      }}
                    >
                      This controls whether the subscription is billed to your
                      organization or directly to the user.
                    </FormHelperText>
                  </FormControl>
                </Grid>
              )}
              {values?.role !== "user" && (
                <Grid item xs={12}>
                  <FormHelperText
                    style={{
                      fontStyle: "italic",
                    }}
                  >
                    Admins are always billed through the organization.
                  </FormHelperText>
                </Grid>
              )}
            </Grid>
          </FormControl>
        </DialogContent>
        <DialogActions className={classes.dialogAction}>
          <Button
            onClick={handleFormSubmit}
            variant="contained"
            color="primary"
            disabled={loader}
          >
            {loader ? "Sending…" : "Send invite"}
          </Button>
          <Button
            onClick={handleClose}
            variant="contained"
            className={classes.actionButton}
            disabled={loader}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withMiddleware(SendInvite);
